import React, { useState } from 'react'
import { getFarms } from '../../sushi/utils'
import Context from './context'
import useYam from '../../hooks/bakery/useYam'
import { MINTTOKEN } from '../../constants/bakery'

const Farms: React.FC = ({ children }) => {
  const [unharvested] = useState(0)

  const yam = useYam()

  const bakeFarms = getFarms(yam)
  const bakeV2Farms = getFarms(yam, MINTTOKEN.BAKEV2)
  const newFarms = getFarms(yam, MINTTOKEN.ALLNEW)
  const endedFarms = getFarms(yam, MINTTOKEN.ENDED)
  const otherFarms = getFarms(yam, MINTTOKEN.OTHERS)
  const allNftFarms = getFarms(yam, MINTTOKEN.ALLNFT)
  const petFarms = getFarms(yam, MINTTOKEN.PET)
  const bPetFarms = getFarms(yam, MINTTOKEN.BPET)
  const weaponFarms = getFarms(yam, MINTTOKEN.WEAPON)
  const bestFarms = getFarms(yam, MINTTOKEN.BEST)
  const weaponnftFarms = getFarms(yam, MINTTOKEN.WEAPONNFT)
  const petnftFarms = getFarms(yam, MINTTOKEN.PETNFT)
  const helmetFarms = getFarms(yam, MINTTOKEN.HELMETNFT)
  const seascapeNftFarms = getFarms(yam, MINTTOKEN.SEASCAPENFT)
  const ethFarms = getFarms(yam, MINTTOKEN.ETH2MASTER)
  const aethFarms = getFarms(yam, MINTTOKEN.AETHMASTER)
  const springFarms = getFarms(yam, MINTTOKEN.TEN)
  const aethAndethFarms = getFarms(yam, MINTTOKEN.AETHANDETH2)
  const bethFarms = getFarms(yam, MINTTOKEN.BETHMASTER)

  const wsoteFarms = getFarms(yam, MINTTOKEN.WSOTE)
  const shieldFarms = getFarms(yam, MINTTOKEN.SHIELD)
  const bryFarms = getFarms(yam, MINTTOKEN.BRY)
  const pcwsFarms = getFarms(yam, MINTTOKEN.PCWS)
  const bakeStakingFarms = getFarms(yam, MINTTOKEN.BAKESTAKING)
  const defi100Farms = getFarms(yam, MINTTOKEN.DEFI100)
  const defi100OLDFarms = getFarms(yam, MINTTOKEN.DEFI100OLD)
  const bananaFarms = getFarms(yam, MINTTOKEN.BANANA)
  const warFarms = getFarms(yam, MINTTOKEN.WAR)
  const war2Farms = getFarms(yam, MINTTOKEN.WAR2)
  const tkoNftFarms = getFarms(yam, MINTTOKEN.TKONFT)
  const hatNftFarms = getFarms(yam, MINTTOKEN.HATNFT)
  const dieselFarms = getFarms(yam, MINTTOKEN.DIESEL)
  const mxFarms = getFarms(yam, MINTTOKEN.MX)
  const aliceFarms = getFarms(yam, MINTTOKEN.ALICE)
  const aliceNftFarms = getFarms(yam, MINTTOKEN.ALICENFT)
  const bondlyNftFarms = getFarms(yam, MINTTOKEN.BONDLYNFT)
  const dfyFarms = getFarms(yam, MINTTOKEN.DFY)
  const gfxFarms = getFarms(yam, MINTTOKEN.GFX)
  const xDittoFarms = getFarms(yam, MINTTOKEN.XDITTO)
  const sactFarms = getFarms(yam, MINTTOKEN.SACT)
  const pet3Farms = getFarms(yam, MINTTOKEN.PET3)
  const hyfiFarms = getFarms(yam, MINTTOKEN.HYFI)
  const ginuFarms = getFarms(yam, MINTTOKEN.GINU)
  const levFarms = getFarms(yam, MINTTOKEN.LEV)
  const bondlyFarms = getFarms(yam, MINTTOKEN.BONDLY)
  const tctFarms = getFarms(yam, MINTTOKEN.TCT)
  const tkoFarms = getFarms(yam, MINTTOKEN.TKO)
  const tkonftStakeFarms = getFarms(yam, MINTTOKEN.TKONFTSTAKE)
  const bmoncnftStakeFarms = getFarms(yam, MINTTOKEN.BMONCNFTSTAKE)
  const bmmnftStakeFarms = getFarms(yam, MINTTOKEN.BMMNFTSTAKE)
  const nftStakeFarms = getFarms(yam, MINTTOKEN.NFTSTAKE)
  const oneInchBakeNftFarms = getFarms(yam, MINTTOKEN.ONEINCHBAKENFT)
  const tko2Farms = getFarms(yam, MINTTOKEN.TKO2)
  const bnrgFarms = getFarms(yam, MINTTOKEN.BNRG)
  const tsaFarms = getFarms(yam, MINTTOKEN.TSA)
  const tlmFarms = getFarms(yam, MINTTOKEN.TLM)
  const xdittoNftFarms = getFarms(yam, MINTTOKEN.XDITTONFT)
  const doggyTlmFarms = getFarms(yam, MINTTOKEN.TLM2)
  const barkTlmFarms = getFarms(yam, MINTTOKEN.TLM3)
  const tokauTlmFarms = getFarms(yam, MINTTOKEN.TLM4)
  const bondly2Farms = getFarms(yam, MINTTOKEN.BONDLY2)
  const toynftStakeFarms = getFarms(yam, MINTTOKEN.TOYNFTSTAKE)
  const gatTlmFarms = getFarms(yam, MINTTOKEN.TLM5)
  const wsgFarms = getFarms(yam, MINTTOKEN.WSG)
  const dogoFarms = getFarms(yam, MINTTOKEN.DOGO)
  const toyNftFarms = getFarms(yam, MINTTOKEN.TOYNFT)
  const tokauFarms = getFarms(yam, MINTTOKEN.TOKAU)
  const eggFarms = getFarms(yam, MINTTOKEN.EGG)
  const kalataFarms = getFarms(yam, MINTTOKEN.KALATA)
  const donFarms = getFarms(yam, MINTTOKEN.DON)
  const ntFarms = getFarms(yam, MINTTOKEN.NT)
  const moniFarms = getFarms(yam, MINTTOKEN.MONI)
  const kxaFarms = getFarms(yam, MINTTOKEN.KXA)
  const nblFarms = getFarms(yam, MINTTOKEN.NBL)

  return (
    <Context.Provider
      value={{
        newFarms,
        endedFarms,
        otherFarms,
        allNftFarms,
        bakeFarms,
        bakeV2Farms,
        petFarms,
        unharvested,
        bPetFarms,
        weaponFarms,
        bestFarms,
        weaponnftFarms,
        petnftFarms,
        helmetFarms,
        ethFarms,
        aethFarms,
        springFarms,
        aethAndethFarms,
        wsoteFarms,
        shieldFarms,
        bryFarms,
        bakeStakingFarms,
        defi100Farms,
        defi100OLDFarms,
        bananaFarms,
        seascapeNftFarms,
        pcwsFarms,
        warFarms,
        tkoNftFarms,
        war2Farms,
        hatNftFarms,
        dieselFarms,
        mxFarms,
        aliceFarms,
        aliceNftFarms,
        bondlyNftFarms,
        dfyFarms,
        gfxFarms,
        xDittoFarms,
        sactFarms,
        pet3Farms,
        hyfiFarms,
        ginuFarms,
        levFarms,
        bondlyFarms,
        tctFarms,
        tkoFarms,
        tkonftStakeFarms,
        bmmnftStakeFarms,
        nftStakeFarms,
        oneInchBakeNftFarms,
        tko2Farms,
        bnrgFarms,
        tsaFarms,
        tlmFarms,
        xdittoNftFarms,
        doggyTlmFarms,
        barkTlmFarms,
        tokauTlmFarms,
        bondly2Farms,
        toynftStakeFarms,
        bmoncnftStakeFarms,
        gatTlmFarms,
        wsgFarms,
        dogoFarms,
        toyNftFarms,
        bethFarms,
        tokauFarms,
        eggFarms,
        kalataFarms,
        donFarms,
        ntFarms,
        moniFarms,
        kxaFarms,
        nblFarms
      }}
    >
      {children}
    </Context.Provider>
  )
}

export default Farms
